import { render, staticRenderFns } from "./DocumentTabs.vue?vue&type=template&id=80493e04"
import script from "./DocumentTabs.js?vue&type=script&lang=js&external"
export * from "./DocumentTabs.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports